import React from 'react';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { italistLegit } from '../../../helpers/routes';
import { LazyImgDpr } from '../../LazyImgDpr/LazyImgDpr';
import { TextContainer } from './common';

export const Authentic: React.FC<{}> = () => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <TextContainer>
        We partner with Italy’s best luxury retailers and work together with them to provide you{' '}
        <a href={localized(italistLegit)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
          100% authentic pieces
        </a>
        , certified twice — by both them and us.
      </TextContainer>
      <a
        className="icons-bbb"
        href="https://www.bbb.org/us/ca/los-angeles/profile/online-retailer/italistcom-1216-902411#bbbseal"
        rel="noopener noreferrer"
        target="_blank"
      >
        <LazyImgDpr
          alt="italist.com, Online Retailer, Los Angeles, CA"
          srcDpr1="https://cdn-images.italist.com/image/upload/c_scale,h_43,q_auto:best/v1583945301/icons/bbb-wide.png"
          srcDpr2="https://cdn-images.italist.com/image/upload/c_scale,h_43,dpr_2,q_auto:best/v1583945301/icons/bbb-wide.png"
          width="120px"
        />
      </a>
    </>
  );
};
